/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-16 09:24:49
 */ 
export const trainVipEn = {
    mchrzpt:"Ccpit certification platform",
    xztc:"Please choose to open the membership package",
    yinpaihuiyuan:"Silver drill members",
    jifengzengzhang:"The rate of integral growth is 2 times",
    jinpaihuiyuan:"The diamond members",
    yingfujine:"Amount payable",
    xieyi:"Upon payment, we agree to the small and medium service platform of ccpit - user agreement.",
    kaitongchenggong:"Congratulations on your successful membership!",
    fanhuiguankan:"Go back to the video",
    qingzailiangfeng:'Please pay in two minutes',
    qingshiyong:'Please use',
    weixin:'WeChat',
    zhifubao:'Alipay',
    zhifubaoruanjian:'Payment software',
    saoyisao:' scan, scan QR code payment',
    quxiaozf:'Cancellation of payment',
    youhuiquan:'Coupon:',
    qxzyouhui:'Please choose a special offer',
    youhuijinger:'Preferential amount:',
    tijiaodd:'place order',
    zhifu:'payment',
    jiaoyicg:'Order transaction succeeded',
    daishenghe:'To audit'

}


// WEBPACK FOOTER //
// ./src/lang/home/trainVip/indexEn.js